import React from "react";
import T from "prop-types";
import { decorators } from "@orange-marmalade/paginate-this";

export function DataTable({ component: Table, ...props }) {
  return <Table {...props} />;
}

DataTable.propTypes = {
  component: T.func.isRequired
};

export default decorators.tabulate(DataTable);



// WEBPACK FOOTER //
// ./app/modules/shared/containers/DataTable/DataTable.jsx